import { gql } from "@apollo/client";

//* All distinct customers who have CF-ordered from the shop (grouped by userFbId)
//* with aggregated stats. Powers the "ລູກຄ້າ CF ທັງໝົດ" list page.
export const GET_CF_CUSTOMERS = gql`
  query CfCustomers(
    $shop: String!
    $searchKeyWord: String
    $createdAt_gte: DateTime
    $createdAt_lt: DateTime
    $platform: String
    $skip: Int
    $limit: Int
  ) {
    cfCustomers(
      shop: $shop
      searchKeyWord: $searchKeyWord
      createdAt_gte: $createdAt_gte
      createdAt_lt: $createdAt_lt
      platform: $platform
      skip: $skip
      limit: $limit
    ) {
      total
      data {
        customerKey
        userFbId
        cfName
        customerName
        customerImage
        phone
        platforms
        orderGroupCount
        orderCount
        totalAmount
        totalPrice
        sumPriceBaht
        sumPriceUsd
        paidCount
        unpaidCount
        firstCfAt
        lastCfAt
      }
    }
  }
`;

//* One customer's full CF order history — all their order groups with the product
//* line items inside each. Reuses the existing orderGroups resolver, filtered by
//* userFbId + shop. Powers the customer detail page.
export const GET_CUSTOMER_ORDER_HISTORY = gql`
  query CustomerOrderHistory(
    $where: OrderGroupWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      totalPrice
      data {
        id
        code
        amount
        cfName
        customerName
        customerImage
        userFbId
        phone
        addressCf
        status
        type
        platform
        totalPrice
        sumPriceBaht
        sumPriceUsd
        sumPrice
        shipPrice
        isPaymented
        paymentType
        createdAt
        live {
          id
          pageName
        }
        post {
          id
          pageName
        }
        orders {
          id
          productName
          cfMessage
          amount
          price
          totalPrice
          currency
          message
          status
          createdAt
        }
      }
    }
  }
`;
